module.exports = __webpack_public_path__ + "static/media/antano-choclo-maiz-y-queso-140g-1920x1080.35f1570f.webp";